// Colic Coverage summary card. Mirrors
// data-component="colic-coverage-summary" from the approved HTML. One-
// line status + a jump to the Colic Coverage review for this horse.
//
// TODO(runtime): hydrate from services/customer-coverage + the
// dist/account-workflows.applications record for this horse. See
// ColicCoverageReview screen for the full flow.
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import type { HorseProfile } from '../mockData.js';

export interface ColicCoverageSummaryProps {
  horse: HorseProfile;
  customerId: string;
}

export function ColicCoverageSummary({ horse, customerId }: ColicCoverageSummaryProps): ReactNode {
  const navigate = useNavigate();
  return (
    <section className="card" data-component="colic-coverage-summary">
      <div className="section-heading">
        <h3>Colic Coverage</h3>
        <span className="needs-pill">{horse.colicCoverage.status}</span>
      </div>
      <div className="horse-related">
        <strong>Application for {horse.name}</strong>
        <p>{horse.colicCoverage.detailLine}</p>
        <button
          className="text-btn"
          type="button"
          onClick={() => navigate(`/colic-coverage/${customerId}`)}
        >
          Review Colic Coverage &rarr;
        </button>
      </div>
    </section>
  );
}
